import { render, staticRenderFns } from "./PageHeaderBlock.vue?vue&type=template&id=6607af1c&"
import script from "./PageHeaderBlock.vue?vue&type=script&lang=js&"
export * from "./PageHeaderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports